<template>
    <transition name="modal-fade">
      <div
        v-if="visible"
        class="fixed inset-0 z-[100] grid place-items-center"
        aria-modal="true"
        role="dialog"
        @keydown.esc.prevent="onEsc"
      >
        <!-- Backdrop -->
        <div
          class="fixed inset-0 bg-black bg-opacity-50"
          @click="onBackdrop"
        />
  
        <!-- Panel -->
        <div
        ref="panel"
        class="relative mx-2 w-full overflow-hidden rounded-2xl bg-white shadow-xl focus:outline-none flex flex-col"
        :class="panelSizeClass"
        tabindex="-1"
        >
          <!-- Header -->
           <!-- Header -->
        <div v-if="hasHeader" class="flex items-center justify-between border-b px-5 py-3">
            <slot name="header">
            <h3 class="text-lg font-semibold">{{ title }}</h3> <!-- صغّر شوية -->
            </slot>
            <!-- <button class="p-2 rounded-md hover:bg-gray-100" @click="close" aria-label="Close">✕</button> -->
        </div>
  
          <!-- Body -->
          <div class="flex-1 overflow-y-auto px-5 py-4">
            <slot />
        </div>
  
          <!-- Footer -->
          <div v-if="$slots.footer" class="border-t px-5 py-3">
                <slot name="footer" />
            </div>
        </div>
      </div>
    </transition>
  </template>
  
  <script>
  export default {
    name: 'BaseModal',
    props: {
      value: { type: Boolean, default: false },          // v-model
      title: { type: String, default: '' },
      size: { type: String, default: 'md' },             // sm | md | lg | xl | 2xl | full
      closeOnBackdrop: { type: Boolean, default: true },
      closeOnEsc: { type: Boolean, default: true },
      destroyOnClose: { type: Boolean, default: false },  // إن بغيتي تتحكم فيه من برا
      lockScroll: { type: Boolean, default: true },       // يمنع سكرول البودي
      showHeader: { type: Boolean, default: true }
    },
    data() {
      return { internalVisible: this.value }
    },
    computed: {
      visible() {
        return this.internalVisible
      },
      hasHeader() {
        return this.showHeader || !!this.$slots.header
      },
      panelSizeClass() {
        // كل الأحجام عندها max-h لضبط العلو
        const h = 'max-h-[85vh]'; // يبان وسط وما يطلعش بزاف
        switch (this.size) {
            case 'sm':  return `max-w-sm  ${h}`;
            case 'md':  return `max-w-lg  ${h}`;
            case 'lg':  return `max-w-2xl ${h}`;
            case 'xl':  return `max-w-3xl ${h}`; // قللّتها شوية
            case '2xl': return `max-w-4xl ${h}`;
            case 'full':return `w-[95vw] h-[90vh]`;
            default:    return `max-w-3xl ${h}`;
        }
    }, 

    },
    watch: {
      value(val) { this.setVisible(val) }
    },
    mounted() {
      this.setVisible(this.value)
    },
    beforeDestroy() {
      if (this.lockScroll) document.body.classList.remove('overflow-hidden')
    },
    methods: {
      setVisible(val) {
        this.internalVisible = val
        this.$emit('input', val)   // v-model sync
        if (val) {
          // lock scroll + focus
          if (this.lockScroll) document.body.classList.add('overflow-hidden')
          this.$nextTick(() => {
            this.$refs.panel && this.$refs.panel.focus()
          })
        } else {
          if (this.lockScroll) document.body.classList.remove('overflow-hidden')
          if (this.destroyOnClose) this.$destroy() // اختياري
        }
        this.$emit(val ? 'open' : 'close')
      },
      close() { this.setVisible(false) },
      onBackdrop() { if (this.closeOnBackdrop) this.close() },
      onEsc() { if (this.closeOnEsc) this.close() }
    }
  }
  </script>
  
  <style scoped>
  .modal-fade-enter-active,
  .modal-fade-leave-active { transition: opacity .15s ease; }
  .modal-fade-enter,
  .modal-fade-leave-to { opacity: 0; }
  .max-h-\[85vh\] {
    max-height: 60vh; /* 85% من ارتفاع نافذة العرض */
   }
  </style>
  